/* @flow */

import { fetchGraphql, fetchQC } from '../utils/ajax';

export type GraphqlVariables = { projectId: string, defs: Array<any> }
export type State = { isFetching: bool, data: any }
export type Action = { type: string, payload: {data: any} }

export const SIDENAV_REQUEST = 'gdc/SIDENAV_REQUEST';
export const SIDENAV_SUCCESS = 'gdc/SIDENAV_SUCCESS';
export const SIDENAV_FAILURE = 'gdc/SIDENAV_FAILURE';
const QC_SIDENAV_SUCCESS = 'gdc/QC_SIDENAV_SUCCESS';

const defFilters = ['clinical', 'data_bundle', 'biospecimen', 'data_file', 'metadata_file'];

function querySidenav({ projectId, defs }: GraphqlVariables): any {
  return {
    query: `query SidenavQuery($projectId: [String]) {
      caseCount: _case_count(project_id: $projectId)
      ${defs.filter(x => defFilters.includes(x.category))
      .map(({ id }) => `${id}Count: _${id}_count(project_id: $projectId)`).join()}
      annotationCount: _annotation_count(project_id: $projectId)
    }`,
    variables: { projectId },
  };
}

export const fetchSidenav = (props: GraphqlVariables, defs: any): any => fetchGraphql(
  [SIDENAV_REQUEST, SIDENAV_SUCCESS, SIDENAV_FAILURE],
  querySidenav(props, defs),
);

export const fetchQCSideNav = ({ program, project, defs }) => fetchQC({
  types: [SIDENAV_REQUEST, {
    type: QC_SIDENAV_SUCCESS,
    meta: {
      defs: defs.filter(x => defFilters.includes(x.category)),
    },
  }, SIDENAV_FAILURE],
  endpoint: 'summary/node_type',
  program,
  project,
});

export default function reducer(state: State = {
  isFetching: false,
  data: {},
}, action: Action): State {
  switch (action.type) {
    case SIDENAV_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case SIDENAV_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case QC_SIDENAV_SUCCESS:
      const qcErrorData = {
        caseCount: action.payload.data.case || 0,
        annotationCount: action.payload.data.annotation || 0,
      };
      action.meta.defs.map(({ id }) => {
        qcErrorData[`${id}Count`] = action.payload.data[id] || 0;
      });
      return {
        ...state,
        isFetching: false,
        data: qcErrorData,
      };
    case SIDENAV_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
}
